export default {
  // 顶部
  header: {
    morning: "日间监测",
    night: "夜间监测",
    dataupdate: "数据更新"
  },
  // 导航
  navbar: {
    current: "当前",
    day: "日",
    week: "周",
    month: "月",
    year: "年"
  },
  // 九宫格
  currentBox: {
    manualrate: "心律检测",
    heartrate: "当前心率",
    heartratePage: "心率",
    bloodpressure: "血压趋势",
    bloodsugar: "血糖趋势",
    sp: "血氧趋势",
    temperature: "体温趋势",
    viscera: "脏腑监测",
    cardiopulmonary: "心肺功能",
    usersleep: "睡眠质量",
    usersleepPage: "睡眠",
    fatiguemonitoring: "疲劳监测",
    fatiguemonitoringPage: "疲劳监测",
    steps: "运动管理",
    ecg: "心电数据",
    huxi: "呼吸频率"
  },
  //模块标题
  components: {
    bu: "步",
    wanbu: "万步",
    jian: "简",
    fan: "繁",
    en:"英",
    shanchu: "删除",
    shousuoya: "收缩压",
    shuzhangya: "舒张压",
    xuetang: "血糖",
    tiwen: "体温",
    zhencghang: "正常",
    fengxian: "风险",
    qianshui: "浅睡(min)",
    shenshui: "深睡(min)",
    qingxing: "清醒(min)",
    jingxi: "静息心率",
    bushu: "步数",
    xinfeiS: ["风险", "正常"],
    sleepname: ["深睡", "浅睡", "清醒"],
    laseUpdate: "最后更新时间",
    warnTitle: "预警列表",
    warnTime: "预警时间",
    warnRate: "预警心率",
    jiankangbaogao: "健康报告",
    chakan: "查看",
    zanwu: "暂无健康报告",
    quxiao: "取 消",
    queding: "确 定",
    yujingcishu: "预警次数",
    yujingjilu: "预警记录",
    reportList: "报告列表",
    weekRateName: ["全天平均", "日间平均", "夜间平均"],
    celiangTime: "测量时间",
    wuxinlv: "今日心律数据没有上传",
    di: "",
    zhou: "",
    yue: "",
    nian: ""
  },
  title: {
    yingyang: "营养元素",
    yanse: "颜色解读",
    heartrate: "心率",
    bloodpre: "血压趋势",
    bloodsugar: "血糖代谢",
    bloodoxygen: "血氧趋势",
    temperature: "体温趋势",
    zangfu: "脏腑监测",
    xinfei: "心肺功能",
    sleep: "睡眠",
    pilao: "疲劳趋势",
    sports: "运动管理",
    canshujeidu: "参数解读",
    zhiliang: "睡眠质量",
    huxipinlv: "呼吸频率", //----------------huxi
    onlinexinlv: "心律图",
    secondaryTitle: {
      xinlvPG: "心率评估",
      xinlvReport: "心率报告",
      bloodPG: "血压评估",
      bloodReport: "血压报告",
      sugarReport: "血糖报告",
      oxygenReport: "血氧报告",
      temperatureReport: "体温报告",
      zangfuReport: "脏腑报告",
      xinfeiReport: "心肺报告",
      xinfeipinggu: "心肺评估",
      canshujiedu: "参数解读",
      sleepReport: "睡眠报告",
      pilaoReport: "疲劳报告",
      youxiaoSport: "有效运动",
      stepsReport: "步数报告",
      breatheReport: "呼吸报告", //-------------------
      xindianReport: "心电报告",
      xinlvOnlinepg: "心律评估"
    }
  },
  heartrate: {
    day: {
      zhengchang: [
        "实时心率监测发现，您的心率处于正常状态。",
        "健康医学研究表明，睡眠基准心率为55-65次/分钟，日间安静时健康心率为75次左右/分钟，表示心脏机能良好，负荷低，是心脏健康和长寿的标志。请您继续保持健康的生活方式、平和的心态、合理的有氧运动。"
      ],
      piandi: [
        "实时心率监测发现，您的心率处于偏低状态。",
        "健康医学研究表明，心率若在40～50次/分钟之间，就会出现胸闷、乏力、头晕等症状，若心率降至35～40次/分钟，则会发生血流动力学改变，使心脑器官的供血受到影响，从而出现胸部闷痛、头晕、晕厥甚至猝死。成人安静时心率低于60次/分钟（一般在45次/分钟以上），称为窦性心动过缓，可见于长期从事重体力劳动的健康人和运动员；或见于甲状腺机能低下、颅内压增高、阻塞性黄疸以及洋地黄、奎尼丁或心得安类药物过量。如果心率低于40次/分钟，应考虑有病态窦房结综合征、房室传导阻滞等情况。如果脉搏强弱不等、不齐，应考虑心房纤颤。如果出现胸闷、乏力、头晕等不适症状，请立即到医院进一步检查"
      ],
      piangao: [
        "实时心率监测发现，您的心率处于偏高状态。",
        "健康医学研究表明，心率过快会危害健康，缩短寿命，增加心血管疾病的发病率和死亡率。成人安静时心率超过100次/分钟（一般不超过160次/分钟），称为窦性心动过速，常见于兴奋、激动、吸烟、饮酒、喝浓茶或咖啡后，或见于疲劳、感染、发热、休克、贫血、缺氧、甲亢、心力衰竭等病理状态下，或见于应用阿托品、肾上腺素、麻黄素等药物后。如果是持续性心动过速，有心慌、气短等明显不适症状，请立即到医院进一步检查，及早针对病因进行治疗。"
      ]
    },
    week: {
      a1: "您本周平均心率为",
      zhengchang: "次/分，处于正常水平，一周内心率异常预警次数为",
      piandi: "次/分，处于偏低水平，一周内心率异常预警次数为",
      piangao: "次/分，处于偏高水平，一周内心率异常预警次数为",
      guodi: "次/分，处于过低水平，一周内心率异常预警次数为",
      guogao: "次/分，处于过高水平，一周内心率异常预警次数为"
    },
    month: {
      a1: "您本月平均心率为",
      zhengchang: "次/分，处于正常水平，一月内心率异常预警次数为",
      piandi: "次/分，处于偏低水平，一月内心率异常预警次数为",
      piangao: "次/分，处于偏高水平，一月内心率异常预警次数为",
      guodi: "次/分，处于过低水平，一月内心率异常预警次数为",
      guogao: "次/分，处于过高水平，一月内心率异常预警次数为"
    },
    year: {
      a1: "您本年平均心率为",
      zhengchang: "次/分，处于正常水平，一年内心率异常预警次数为",
      piandi: "次/分，处于偏低水平，一年内心率异常预警次数为",
      piangao: "次/分，处于偏高水平，一年内心率异常预警次数为",
      guodi: "次/分，处于过低水平，一年内心率异常预警次数为",
      guogao: "次/分，处于过高水平，一年内心率异常预警次数为"
    }
  },
  bloodpre: {
    day: {
      gaoxueya: [
        "实时血压趋势监测发现，您的血压趋势处于高血压状态。",
        "高血压是最常见的慢性病，也是心脑血管病最主要的危险因素。当血压突然升高到一定程度时，会出现剧烈头痛、呕吐、心悸、眩晕等症状，严重时会发生神志不清、抽搐，这就属于急进型高血压和高血压危重症，多会在短期内发生严重的心、脑、肾等器官的损害和病变，如中风、心梗、肾衰等。高血压患者要注意劳逸结合，适量运动，合理饮食，积极进行药物治疗。高血压患者的饮食上应遵守低盐、低脂、低热量的原则，并注意饮食结构的合理搭配；饮食不宜过饱、过快；最好忌不良嗜好，如烟、酒等。"
      ],
      dixueya: [
        "实时血压趋势监测发现，您的血压趋势处于低血压状态。",
        "根据低血压的起病形式将其分为急性和慢性两大类。急性低血压是指患者血压由正常或较高的水平突然而明显下降，临床上常因脑、心、肾等重要脏器缺血出现头晕、眼黑、肢软、冷汗、心悸、少尿等症状，严重者表现为晕厥或休克。慢性低血压是指血压持续低于正常范围的状态。对体质虚弱者要加强营养补充，增加饮水量，生活要有规律，防止过度疲劳，要保持良好的精神状态，适当加强锻炼，提高身体素质，改善神经、血管的调节功能，加速血液循环，减少直立性低血压的发作。"
      ],
      zhengchang: [
        "实时血压趋势监测发现，您的血压趋势处于正常压状态。",
        "高血压是一种可防可控的疾病，应该积极养成预防意识，通过科学的数据、经常性血压值的测量，达到及早发现高血压、及早治疗，及时了解自己的血压正常值的目的。对血压130～139/85～89mmHg正常高值阶段、超重/肥胖、长期高盐饮食、过量饮酒者应进行重点干预，定期健康体检，积极控制危险因素。"
      ]
    },
    week: {
      a1: "您本周平均血压为收缩压",
      a2: "mmHg、舒张压",
      zhengchang: "mmHg，处于正常水平。",
      piandi: "mmHg，处于偏低水平。",
      piangao: "mmHg，处于偏高水平。",
      gaoyagao: "mmHg，处于高压偏高、低压正常水平。",
      diyagao: "mmHg，处于高压正常、低压偏高水平。"
    },
    month: {
      a1: "您本月平均血压为收缩压",
      a2: "mmHg、舒张压",
      zhengchang: "mmHg，处于正常水平。",
      piandi: "mmHg，处于偏低水平。",
      piangao: "mmHg，处于偏高水平。",
      gaoyagao: "mmHg，处于高压偏高、低压正常水平。",
      diyagao: "mmHg，处于高压正常、低压偏高水平。"
    },
    year: {
      a1: "您本年平均血压为收缩压",
      a2: "mmHg、舒张压",
      zhengchang: "mmHg，处于正常水平。",
      piandi: "mmHg，处于偏低水平。",
      piangao: "mmHg，处于偏高水平。",
      gaoyagao: "mmHg，处于高压偏高、低压正常水平。",
      diyagao: "mmHg，处于高压正常、低压偏高水平。"
    }
  },
  bloodsugar: {
    day: {
      gaoxuetang: [
        "实时血糖监测发现，您的血糖疑似处于高血糖风险状态。请密切关注趋势变化和临床症状，及时到医院进一步检查，及早实施干预。短时间、一次性的高血糖对人体无严重损害。比如在应激状态下或情绪激动、高度紧张时，可出现短暂的高血糖；一次进食大量的糖类，也可出现短暂高血糖；随后，血糖水平逐渐恢复正常。然而长期的高血糖会使全身各个组织器官发生病变，导致急慢性并发症的发生。如失水、电解质紊乱、营养缺乏、抵抗力下降、肾功能受损、神经病变、眼底病变、心脑血管疾病、糖尿病足等。控制高血糖势在必行。"
      ],
      tangniaobing: [
        "实时血糖监测发现，您的血糖疑似处于糖尿病风险状态。请密切关注趋势变化和临床症状，及时到医院检查诊断。目前尚无根治糖尿病的方法，但通过多种治疗手段可以控制好糖尿病。主要包括5个方面：糖尿病患者的教育，自我监测血糖，饮食治疗，运动治疗和药物治疗。"
      ],
      zhengchang: [
        "实时血糖监测发现，您的血糖处于正常状态。请继续保持良好的生活习惯、心理平衡、戒烟限酒、合理膳食、适量运动锻炼。"
      ],
      dixuetang: [
        "实时血糖监测发现，您的血糖疑似处于低血糖风险。请密切关注趋势变化和临床症状，及时到医院检查诊断。低血糖症是一组多种病因引起的以静脉血浆葡萄糖（简称血糖）浓度过低，临床上以交感神经兴奋和脑细胞缺氧为主要特点的综合征。低血糖的症状通常表现为出汗、饥饿、心慌、颤抖、面色苍白等，严重者还可出现精神不集中、躁动、易怒甚至昏迷等。"
      ]
    },
    week: {
      a1: "您本周平均血糖值为",
      gaoxuetang: "mmol/L，疑似存在高血糖风险。",
      tangniaobing: "mmol/L，疑似存在糖尿病风险",
      zhengchang: "mmol/L，处于正常水平。",
      dixuetang: "mmol/L，疑似低血糖风险。"
    },
    month: {
      a1: "您本月平均血糖值为",
      gaoxuetang: "mmol/L，疑似存在高血糖风险。",
      tangniaobing: "mmol/L，疑似存在糖尿病风险",
      zhengchang: "mmol/L，处于正常水平。",
      dixuetang: "mmol/L，疑似低血糖风险。"
    },
    year: {
      a1: "您本年平均血糖值为",
      gaoxuetang: "mmol/L，疑似存在高血糖风险。",
      tangniaobing: "mmol/L，疑似存在糖尿病风险",
      zhengchang: "mmol/L，处于正常水平。",
      dixuetang: "mmol/L，疑似低血糖风险。"
    }
  },
  bloodoxygen: {
    day: {
      piandi: [
        "实时血氧饱和度监测发现，您的血氧饱和度处于偏低状态。请养成持良好的生活习惯、戒烟限酒、合理膳食、适量运动锻炼。请密切关注趋势变化和临床症状，或及时到医院进一步检查。"
      ],
      dixueyang: [
        "实时血氧饱和度监测发现，您的血氧饱和度处于低血氧症状态。请密切关注趋势变化和临床症状，及时到医院检查治疗。"
      ],
      zhengchang: [
        "实时血氧饱和度监测发现，您的血氧饱和度处于正常状态。请继续保持良好的生活习惯、戒烟限酒、合理膳食、适量运动锻炼。"
      ]
    },
    week: {
      a1: "您本周平均血氧为",
      piandi: "%，疑似低血氧。",
      dixueyang: "%，处于偏低水平。",
      zhengchang: "%，处于正常水平。"
    },
    month: {
      a1: "您本月平均血氧为",
      piandi: "%，疑似低血氧。",
      dixueyang: "%，处于偏低水平。",
      zhengchang: "%，处于正常水平。"
    },
    year: {
      a1: "您本年平均血氧为",
      piandi: "%，疑似低血氧。",
      dixueyang: "%，处于偏低水平。",
      zhengchang: "%，处于正常水平。"
    }
  },
  xinfei: {
    day: {
      yichang: [
        "实时心肺功能监测发现，您的心肺功能为异常。",
        "心肺功能不好，容易造成血液循环不流畅、呼吸不通畅，导致人体内脏供氧不足，出现呼吸困难、胸闷气短、静脉怒张、四肢无力、咳嗽、水肿、心率衰竭等状况。规则性、持续性、有节奏的有氧运动可以锻炼和增强心肺功能，如步行、爬山、游泳、慢跑、跳绳、骑行等。每周从事这类运动3至4次，每次30分钟，即可收到很好的效果。如果心肺功能长期处于异常状态，建议及时去医院诊断治疗。"
      ],
      zhengchang: [
        "实时心肺功能监测发现，您的心肺功能为良好。",
        "请继续保持有一定强度、能持续进行的促进心肺功能的有氧运动。如骑车、游泳、爬楼梯、慢跑、快速走路、爬山、跳绳等典型的有氧运动。"
      ]
    },
    week: {
      zhengchang: "您本周心肺功能处于良好状态。",
      yichang: {
        d1: ["您本周心肺功能出现"],
        d2: ["次异常状态。"]
      }
    },
    month: {
      zhengchang: "您本月心肺功能处于良好状态。",
      yichang: {
        d1: ["您本月心肺功能出现"],
        d2: ["次异常状态。"]
      }
    },
    year: {
      zhengchang: "您本年心肺功能处于良好状态。",
      yichang: {
        d1: ["您本年心肺功能出现"],
        d2: ["次异常状态。"]
      }
    }
  },
  temperature: {
    day: {
      zhengchang: [
        "实时体温趋势监测发现，您的体温趋势处于正常状态。请继续保持良好的生活习惯、适量运动锻炼。"
      ],
      dire: [
        "实时体温趋势监测发现，您的体温趋势处于低热状态。请密切关注体温变化趋势和与疾病有关的临床症状"
      ],
      zhongre: [
        "实时体温趋势监测发现，您的心体温趋势处于中热状态。请密切关注体温变化趋势和与疾病有关的临床症状，或及时到医院进一步检查。"
      ],
      gaore: [
        "实时体温趋势监测发现，您的体温趋势处于高热状态。请立即到医院进一步检查。"
      ],
      text: [
        "系统监测您的数据较少，请每天坚持佩戴云环，以便获取更准确的健康报告。"
      ]
    },
    week: {
      a1: "您本周平均体温为",
      zhengchang: "℃处于正常水平。",
      dire: "℃处于低热水平。",
      zhongre: "℃处于中热水平。",
      gaore: "℃处于高热水平。"
    },
    month: {
      a1: "您本月平均体温为",
      zhengchang: "℃处于正常水平。",
      dire: "℃处于低热水平。",
      zhongre: "℃处于中热水平。",
      gaore: "℃处于高热水平。"
    },
    year: {
      a1: "您本年平均体温为",
      zhengchang: "℃处于正常水平。",
      dire: "℃处于低热水平。",
      zhongre: "℃处于中热水平。",
      gaore: "℃处于高热水平。"
    }
  },
  zangfu: {
    day: {
      fengxian: [
        "实时脏腑状态监测发现，您的脏腑监测存在风险状态。请密切关注趋势变化和与疾病有关的临床症状，或及时到医院进一步检查。"
      ],
      yichang: [
        "实时脏腑状态监测发现，您的脏腑状态处于异常状态。请遵循自然规律，按照人体脏腑运行的时间节律进行正常的生理活动，努力使人体处于平衡和谐的状态，保持生命进程的健康状态。"
      ],
      zhengchang: [
        "实时脏腑状态监测发现，您的脏腑状态处于正常状态。请继续保持良好的昼夜节律生理活动习惯及生活方式。"
      ]
    },
    week: {
      fengxian: "您本周脏腑状态为风险。",
      yichang: "您本周脏腑状态为异常。",
      zhengchang: "您本周脏腑状态为正常。"
    },
    month: {
      fengxian: "您本月脏腑状态为风险。",
      yichang: "您本月脏腑状态为异常。",
      zhengchang: "您本月脏腑状态为正常。"
    },
    year: {
      fengxian: "您本年脏腑状态为风险。",
      yichang: "您本年脏腑状态为异常。",
      zhengchang: "您本年脏腑状态为正常。"
    }
  },
  sleep: {
    day: {
      you: [
        "实时睡眠监测发现，您的睡眠质量为优。",
        "请继续保持良好的睡眠习惯，每天晚上九点左右泡个澡舒缓身心，换上舒适的睡衣，调暗灯光，减少噪音，拒绝咖啡等会干扰睡眠的食物，从内到外营造一个舒适的睡眠环境。"
      ],
      liang: [
        "实时睡眠监测发现，您的睡眠质量为良。",
        "请养成持良好的睡眠习惯，跟自己指定一个睡眠协议，每天晚上九点左右泡个澡舒缓身心，换上舒适的睡衣，调暗灯光，减少噪音，拒绝咖啡等会干扰睡眠的食物，从内到外营造一个舒适的睡眠环境。"
      ],
      cha: [
        "实时睡眠监测发现，您的睡眠质量为差。",
        "长期睡眠不足和睡眠障碍可导致抑郁症的生成，失眠往往是抑郁症的先兆之一；加速皮肤衰老，出现皮肤蜡黄，眼睛浮肿；引发严重心脏疾病、心脏病发作、心脏衰竭、心律不齐、高血压、中风、糖尿病等严重的健康问题；增加死亡风险，将使因心血管疾病而死亡的机率增加一倍；睡眠不足可损害人的注意力，警觉性，专注性，推理能力以及解决问题的能力。"
      ]
    },
    week: {
      a1: "本周平均睡眠时间为每天",
      a2: "，平均深睡时长为",
      you: "，您本周睡眠质量优。",
      liang: "，您本周睡眠质量为良。",
      cha: "，您本周睡眠质量为差。"
    },
    month: {
      a1: "本月平均睡眠时间为每天",
      a2: "，平均深睡时长为",
      you: "，您本月睡眠质量优。",
      liang: "，您本月睡眠质量为良。",
      cha: "，您本月睡眠质量为差。"
    },
    year: {
      a1: "本年平均睡眠时间为每天",
      a2: "，平均深睡时长为",
      you: "，您本年睡眠质量优。",
      liang: "，您本年睡眠质量为良。",
      cha: "，您本年睡眠质量为差。"
    }
  },
  fat: {
    day: {
      pilao: [
        "实时疲劳监测发现，您处于疲劳状态。",
        "连续或过度疲劳将会影响身体健康，甚至引发人体心衰、肺衰、肾衰、心肌梗、脑溢血等病症造成的猝死。请立即采取休息和恢复措施，消除疲劳，保障身体健康。"
      ],
      pilaoqushi: [
        "实时疲劳监测发现，您有疲劳的趋势或处于疲劳未恢复的状态，有疲劳累积现象。",
        "请适当调整工作或运动量，注意休息，并养成良好的作息习惯、舒缓身心、释放压力。"
      ],
      zhengchang: [
        "实时疲劳监测发现，您处于正常状态。请继续保持良好的作息习惯、舒缓身心、释放压力、适量运动。"
      ]
    },
    week: {
      pilaoqushi: "您本周有疲劳的趋势或处于疲劳未恢复的状态，有疲劳累积现象。",
      zhengchang: {
        d1: ["您本周平均晨起静息心率为"],
        d2: ["次/分钟，处于正常状态。"]
      },
      santian: "您本周晨起静息心率连续三天增高，处于疲劳状态。",
      liangtian: "您本周晨起静息心率连续两天增高，处于疲劳趋势状态。",
      text:
        "系统监测您的数据较少，请每天坚持佩戴云环，以便获取更准确的健康报告。"
    },
    month: {
      a1: "您本月出现",
      pilaoqushi: "天疲劳趋势。",
      zhengchang: {
        d1: ["您本月平均晨起静息心率为"],
        d2: ["次/分钟，处于正常状态。"]
      },
      pilao: "天疲劳状态。",
      text:
        "系统监测您的数据较少，请每天坚持佩戴云环，以便获取更准确的健康报告。"
    },
    year: {
      a1: "您本年出现",
      pilaoqushi: "天疲劳趋势。",
      pilao: "天疲劳状态。",
      zhengchang: {
        d1: ["您本年平均晨起静息心率为"],
        d2: ["次/分钟，处于正常状态。"]
      },
      text:
        "系统监测您的数据较少，请每天坚持佩戴云环，以便获取更准确的健康报告。"
    }
  },
  steps: {
    day: {
      weidabiao: [
        "实时运动监测发现,您的运动量未达标,请您加强锻炼。",
        "健康医学研究表明，把健身运动变成生活的一部分，有利于身体健康、延年益寿。有效的运动管理以每天运动30分钟，每周累计运动5次以上为宜。运动时间可以累积，但每次有效运动的持续时间应不少于10分钟。"
      ],
      dabiao: [
        "实时运动监测发现,您的运动量已达标,请您继续保持。",
        "健康医学研究表明,正常成年人每天应步行7000步或达到相当于7000步的中等强度的有氧运动,有利于心肺健康,提高机体免疫力加强身体平衡能力和预防跌倒。有氧运动是成年人最常见的最有效运动方式。有氧运动包括步行、健走、跳舞、游泳、墩地、修剪园林、慢速骑车等。每日有效运动量应超过500大卡以上。"
      ]
    },
    week: {
      a1: "您本周平均运动步数为",
      a2: "步,平均有效运动量为",
      dabiao: "大卡，已达标。",
      weidabiao: "大卡，未达标。"
    },
    month: {
      a1: "您本月平均运动步数为",
      a2: "步,平均有效运动量为",
      dabiao: "大卡，已达标。",
      weidabiao: "大卡，未达标。"
    },
    year: {
      a1: "您本年平均运动步数为",
      a2: "步,平均有效运动量为",
      dabiao: "大卡，已达标。",
      weidabiao: "大卡，未达标。"
    }
  },
  ecg: {
    current:
      "心电图是身体各部位在每一心动周期中，发生有规律的电变化的活动图型，对各种心律失常和传导障碍的诊断和分析具有一定的价值。常用于冠心病心肌缺血、心肌梗死和各种心律失常的早期诊断方法。"
  },
  breathe: {
    current:
      "正常成人呼吸频率为每分钟12~20次。呼吸减慢常见于代谢率降低、麻醉过量、休克以及明显颅内压增髙等。呼吸增快主要见于发热、疼痛、贫血、甲状腺功能亢进症、心力衰竭、肺炎肺栓塞、胸膜炎、支气管哮喘及神经、精神障碍等。"
  },
  manualrate: {
    a: "本次连续区间检测发现你的心律值为",

    yichangdi: "bpm，<60次/分，疑似缓慢型心律失常。",
    yichanggao: "bpm，>100次/分，疑似快速型心律失常。",
    zhengchang: "bpm，位于60次/分-100次/分之间，心律正常。",
    b:
      "请密切关注心率波动变化，如感觉心悸、心慌、胸闷、头晕、出汗等症状，应尽快去医院检查。"
  },
  elementList: [
    { id: "钙" },
    { id: "锌" },
    { id: "镁" },
    { id: "铁" },
    { id: "铜" },
    { id: "水" },
    { id: "热量" },
    { id: "脂肪" },
    { id: "蛋白质" },
    { id: "维C" },
    { id: "维D" },
    { id: "维E" }
  ],
  healthElement: {
    ri: "今日",
    shishi: "实时",
    zhou: "本周",
    yue: "本月",
    nian: "年",
    p1: "通过对您",
    p2: "健康数据监测分析发现，您",
    piandi: "含量偏高",
    pangao: "含量偏高",
    danbai: "蛋白质",
    gai: "钙",
    mei: "镁",
    reliang: "热量",
    shui: "水",
    tie: "铁",
    tong: "铜",
    weiC: "维C",
    weiD: "维D",
    weiE: "维E",
    xin: "锌",
    zhifang: "脂肪",
  },
  // 标签库
  tag: {
    jiankang: "点击营养元素查看相关解读",
    weiceliang: "未检测",
    yijiance: "已测量",
    xiaoshi: "小时",
    fen: "分",
    quxiao: "取消",
    queren: "确认",
    tiao: "条",
    bu: "步",
    cal: "大卡",
    mile: "公里",
    zoule: "总共走了",
    dian: "点",
    guanbi: "关闭",
    zhengchang: "正常",
    yichang: "异常",
    fengxian: "风险",
    piangao: "偏高",
    piandi: "偏低",
    dabiao: "达标",
    weidabiao: "未达标",
    you: "优",
    liang: "良",
    cha: "差",
    gaoyagao: "高压高",
    diyadi: "低压低",
    diyagao: "低压高",
    dixueyang: "低血氧",
    gaore: "高热",
    dire: "低热",
    tangniaobingfengxian: "糖尿病风险",
    gaoxuetangfengxian: "高血糖风险",
    dixuetangfengxian: "低血糖风险",
    ji: "级",
    pilao: "疲劳",
    pilaoqushi: "疲劳趋势",
    shipin: "视图支持两指滑动缩放",
    pzxtqst: "平均血糖趋势图",
    canshujiedu: "参数解读",
    yujingjilu: "预警记录",
    zongyujing: "总预警",
    zishi: "子时",
    choushi: "丑时",
    yinshi: "寅时",
    maoshi: "卯时",
    chenshi: "辰时",
    sishi: "巳时",
    wushi: "午时",
    weishi: "未时",
    shenshi: "申时",
    youshi: "酉时",
    xushi: "戌时",
    haishi: "亥时",
    hanliangpiandi: "元素含量偏低",
    hanliangzhengchang: "元素含量正常",
    hanliangpiangao: "元素含量偏高",
    suffix: {
      tiao: "条",
      bpm: "bpm",
      baifenhao: "%",
      bu: "步",
      mol: "mmol/L",
      hh: "mmHg",
      du: "℃",
      dan: "（胆）",
      gan: "（肝）",
      fei: "（肺）",
      dachang: "（大肠）",
      wei: "（胃）",
      pi: "（脾）",
      xin: "（心）",
      xiaochang: "（小肠）",
      pangguang: "（膀胱）",
      shen: "（肾）",
      xinbao: "（心包）",
      sanjiao: "（三焦）",
      danwei: "次/分"
    },
    canshujieduContent: {
      xinlv: [
        {
          title: "心率健康",
          content:
            "<p>心率是心脏每分钟搏动的次数。正常成年人安静时的心率有显著的个体差异，平均在75次/分左右（60—100次/分之间）。心率变化与心脏疾病密切相关，心率超过160次/分钟，或低于40次/分钟，大多见于心脏病患者，如常伴有心悸、胸闷等不适感，应及早进行详细检查，以便针对病因进行治疗。</p>"
        },
        {
          title: "实时心率监测",
          content:
            "<p>实时心率监测，是指全天24小时进行连续心率监测，长时间连续记录并分析心脏活动讯号，发现心率及心率相关数值的变化趋势的方法。通过实时心率监测可以对心脑血管疾病发展进行监控和预警，提高对非持续性心血管疾病的检出率。</p>"
        },
        {
          title: "心率昼夜节律",
          content:
            "<p>典型的心脏昼夜节律变化呈现为勺形心率状态，即夜间心率平均值比白天心率平均值低10%-20%。夜间睡眠后心率开始减慢，于3-5点到达穀值，清晨觉醒后心率逐渐增快，在3-4小时内达到峰值，完成全天的波动週期。心率昼夜节律的失衡往往是心血管事件发生的预兆，所以维持心率昼夜节律的平衡十分重要。</p>"
        },
        {
          title: "睡眠基准心率",
          content:
            "<p>睡眠基准心率为55-65次/分钟，表示心脏机能良好，负荷低。对于高血压患者，基准心率每新增10次/分钟，主要心血管事件风险新增8%；对于冠心病患者，心率>70次/分钟，全因死亡风险新增40%，心力衰竭住院风险新增两倍以上。</p>"
        }
      ],
      blood: [
        {
          title: "血压健康",
          content:
            "<p>血压是血液在血管内流动时，作用于血管壁的压力，它是推动血液在血管内流动的动力。</p><p>收缩压：心室收缩时，主动脉压急剧升高 ，在收缩期的中期达到最高值，这时的动脉血压值称为收缩压，也称为“高压”。</p><p>舒张压：心室舒张时，主动脉压下降，在心舒末期动脉血压的最低值称为舒张压，也称为“低压”。</p><p>脉压：收缩压减舒张压的差值。</p><p>理想血压：收缩压<120 mmHg、舒张压<80mmHg。</p><p>正常血压：90mmHg<收缩压<140mmHg、60mmHg<舒张压<90mmHg。</p><p>临界高血压（临床观测经验）：收缩压在140～160mmHg（18.6～21.3kPa），舒张压在90～95mmHg（12.0～12.6kPa）。</p>"
        },
        {
          title: "血压变动",
          content:
            "<p>血压升高：血压测值受多种因素的影响，如情绪激动、紧张、运动等；若在安静、清醒的条件下采用标准测量方法，至少3次非同日血压值达到或超过收缩压140mmHg和（或）舒张压90mmHg，即可认为有高血压，如果仅收缩压达到标准则称为单纯收缩期高血压。高血压绝大多数是原发性高血压，约5%继发于其他疾病，称为继发性或症状性高血压，如慢性肾炎等。高血压是动脉粥样硬化和冠心病的重要危险因素，也是心力衰竭的重要原因。</p><p>血压降低：凡血压低于90/60mmHg时称低血压。持续的低血压状态多见于严重病症，如休克、心肌梗死、急性心脏压塞等。低血压也可有体质的原因，患者自诉一贯血压偏低，患者口唇黏膜局部发白，当心脏收缩和舒张时则发白的局部边缘发生有规律地红、白交替改变即为毛细血管搏动征。</p>"
        },
        {
          title: "高血压易患人群",
          content:
            "<p>1.父母、 兄弟、姐妹等家属有高血压病史者；</p><p>2.肥胖者；</p><p>3.过分摄入盐分者；</p><p>4.过度饮酒者；</p><p>5.神经质易焦躁者。</p>"
        },
        {
          title: "低血压易患人群",
          content:
            "<p>1.青年女性；</p><p>2.长期卧床休息者；</p><p>3.病后初愈者；</p><p>4.体质瘦弱者；</p><p>5.更年期妇女；</p><p>6.老年人群。</p>"
        },
        {
          title: "治疗误区",
          content:
            "<p>高血压患者应走出不愿意服药、不规律服药、不难受不吃药的误区，积极进行药物治疗。</p><p>建议高血压患者一定到医院查找病因，检查有无糖尿病、心肾损害或相关疾病，并按规律服药和使用正规医疗器械，平稳降压。特别重要的是，高血压“高危和很高危”患者必须立即开始药物治疗。对高血压患者而言，治疗的主要目标是最大程度地降低心血管事件的危险性。</p><p>因此，必须最大程度地对高血压本身和相关的、能够改变的心血管病危险因素进行干预治疗。对于所有高血压患者而言，降低血压是“硬道理”。高血压患者心率＞80次即应啓动干预治疗, 心率目标设定为60～75次/分。对于合并冠心病、心力衰竭患者的心率控制目标更应严格,心率＞70次/分就应当给予干预治疗, 最好使心率控制在55～60次/分之间。</p>"
        }
      ],
      sugar: [
        {
          title: "血糖",
          content:
            "<p>血中的葡萄糖称为血糖（Glu）。葡萄糖是人体的重要组成成分，也是能量的重要来源。正常人体每天需要很多的糖来提供能量，为各种组织、脏器的正常运作提供动力。所以血糖必须保持一定的水平才能维持体内各器官和组织的需要。正常人血糖的産生和利用处于动态平衡的状态，维持在一个相对稳定的水平，这是由于血糖的来源和去路大致相同的结果。</p>"
        },
        {
          title: "血糖的来源",
          content: `<p>血糖的来源包括：①食物消化、吸收；②肝内储存的糖原分解；③脂肪和蛋白质的转化。</p>
                    <p>血糖的去路包括：①氧化转变为能量；②转化为糖原储存于肝脏、肾脏和肌肉中；③转变为脂肪和蛋白质等其他营养成分加以储存。</p>
                    <p>胰岛是体内调节血糖浓度的主要器官，肝脏储存肝糖元。此外，血糖浓度还受神经、内分泌激素的调节。</p>`
        },
        {
          title: "正常血糖值",
          content: `<p>空腹血糖正常值：一般空腹全血血糖为3.9～6.1毫摩尔/升。空腹全血血糖≥6.7毫摩尔/升，2次重複测定可诊断为糖尿病。</p>
                    <p>餐后血糖正常值：餐后1小时血糖6.7-9.4毫摩/升，餐后2小时血糖≤7.8毫摩/升。</p>
                    <p>目前国际通用的糖尿病诊断是空腹(禁食超过8小时) 血糖高于7.0mmol/L以上，或任何时候(不管是否空腹) 血糖高于11.1mmol/L以上。</p>`
        },
        {
          title: "餐后血糖的临床意义",
          content: `<p>人体从进食早餐开始，到晚餐后，机体持续处于营养物质的吸收过程，共持续约20个 时。从严格意义上来说，真正的空腹状态仅仅只有早餐前的4 个小时左右，也就是说一天中人体大部分时候均处于餐后状态。而持续的餐后血糖，不仅持续压榨著患者本就受损的胰岛细胞不断释放胰岛素，让胰岛细胞不得休息，最终损伤加重，胰岛功能耗竭。还会对全身脏 、血管、神经进行“糖毒性”损伤，引发多种并发症。 </p>
                    <p>长期跟踪监测餐后血糖有助于早期干预，降低糖尿病发病率。空腹血糖值正常时，但是餐后血糖却介于健康人和糖尿病患者之间，被称作耐糖量受损，此时如果不进行干预，部分患者就会发展成2型糖尿病患者。所以，提高对餐后血糖的重视，能够有效降低糖尿病发病风险。</p>`
        }
      ],
      oxygen: [
        {
          title: "血氧饱和度",
          content:
            "<p>血氧饱和度(SpO2)是血液中被氧结合的氧合血红蛋白(HbO2)的容量占全部可结合的血红蛋白(Hb，hemoglobin)容量的百分比，即血液中血氧的浓度，它是呼吸循环的重要生理参数，是检查体内血液供氧能力的一个指标，反应肺功能的指标。正常人体动脉血的血氧饱和度为98% ，低于94%为供氧不足。</p>"
        },
        {
          title: "缺氧症状",
          content:
            "<p>血氧饱和度过低是氧气不能有效地结合血红蛋白，会出现周围循环缺血，指甲发白，会引起呼吸的改变、严重时可引起心脏、肝肾脑的变化。血氧饱和度出现问题表现为呼吸急促、嘴唇发绀、全身无力、心率快等症状。</p>"
        },
        {
          title: "缺氧危害",
          content: `<p>缺氧是机体氧供与氧耗之间出现的不平衡，即组织细胞代谢处于乏氧状态。缺氧的危害与缺氧程度、发生速度及持续时间有关。严重低氧血症是麻醉死亡的常见原因，约占心脏骤停或严重脑细胞损害死亡的1/3到2/3。</p>
                    <p>缺氧对机体有著巨大的影响。比如对CNS，肝、肾功能的影响。低氧时首先出现的是代偿性心率加速，心搏及心排血量增加，循环系统以高动力状态代偿氧含量的不足。同时産生血流再分配，脑及冠状血管选择性扩张以保障足够的血供。但在严重的低氧状况时，由于心内膜下乳酸堆积，ATP合成降低，産生心肌抑制，导致心动过缓，期前收缩，血压下降与心排血量降低，以及出现室颤等心率失常乃至停搏。</p>`
        },
        {
          title: "低氧血症",
          content: `<p>低氧血症是指血液中含氧不足，动脉血氧分压（PaO2）低于同龄人的正常下限，主要表现为血氧分压与血氧饱和度下降。成人正常动脉血氧分压（PaO2）：83～108mmHg。一般认为血氧饱和度低于90%即可明确为低血氧症。引起低氧血症的常见原因有：吸入氧分压过低；肺泡通气不足；弥散功能障碍；肺泡通气/血流比例失调；右向左分流。</p>`
        }
      ],
      zangfu: [
        {
          title: "脏腑",
          content: `<p>脏腑学说是通过观察人体外在现象、征象，来研究人体内在脏腑的生理功能、病理变化及其相互关系的学说。包括构成人体的基本机制——五脏、六腑、奇恒之腑、经络等全身组织器官的生理、病理及其相互关系。</p>
                    <p>脏腑是人体内脏的总称，分为五脏和六腑两大类：五脏是心、肝、脾、肺、肾；六腑是胆、胃、大肠、小肠、膀胱和三焦；此外还有一个心包络，它是心的外卫，在功能和病态上，与心脏相互一致。</p>`
        },
        {
          title: "脏腑与健康",
          content:
            "<p>人为什么会生病? 许多原因是因为人违背了自然的时间法则。中医哲学主张天人合一，认为人是大自然的组成部分，人的生活习惯应该符合自然规律。脏腑学说把人的脏腑与12个时辰的兴衰变化联系起来，环环相扣，十分有序。时间养生是中国中医源远流长的人体健管理成果，科学掌握和应用脏腑学说，能够促进人体健康养生，预防和排查人体疾病。</p>"
        },
        {
          title: "脏腑辨证",
          content: `<p>脏腑辨证是根据脏腑的生理功能和病理特点，辨别脏腑病位及脏腑阴阳、气血、虚实、寒热等变化，为治疗提供依据的辨证方法。</p>
                    <p>中医学的辨证方法虽然多种多样，各有特点，但最后大都落实在脏腑的病变上，也即证候的定位是辨证内容组成的基本要素之一。进一步分析疾病的具体病理变化，必须落实到脏腑上来，用脏腑辨证的方法才能解决。脏腑辨证的主要内容包括脏病辨证、腑病辨证及脏腑兼病辨证等。</p>`
        },
        {
          title: "脏腑排毒",
          content: `<p>造成人体疾病和衰老的原因，无非就是气血失调、阴阳失衡、脏腑功能失调等因素。人体协调阴阳平衡和脏腑的功能，会随著年龄的增长逐渐减弱。</p>
                    <p>遵循自然规律，按照人体脏腑运行的时间节律进行人体正常的生理活动，就能让脏腑器官和系统有机协调地工作，有效排除内外毒素，使人体处于平衡和谐的状态，保持生命进程的健康状态。</p>
                    <p>如果违背自然规律，破坏脏腑运行机制，长此以往脏腑健康系统就会出现紊乱，人体极易受到外毒、内毒等的侵害，就会使阴阳失衡加速，从而影响营养物质的吸收、转化及毒素的排出，损害脏腑组织，使其功能减退，就会致使人体发生疾病和提前衰老。</p>`
        }
      ],
      hour: [
        {
          id: 1,
          title: "子",
          sub: "胆",
          content: `<p>23点至1点（子时）</p>
                    <p>胆经旺：</p>
                    <p>子时睡得足，黑眼圈不露。</p>
                    <p>养生之道：</p>
                    <p>这时应上床睡觉，利于骨髓造血。</p>
                    <p>所属病候：</p>
                    <p>颞痛、眼角痛、缺盆肿痛、腋下肿、胸胁、肋、股外侧、膝胫骨外踝前诸节皆痛等。</p>
                    <p>人体状况：</p>
                    <p>传统医学认为“肝之余气，泄于明胆，聚而成精”，人在子时前入眠，胆方能完成代谢。“胆汁有多清，脑就有多清”，子时前入睡者，晨醒后头脑清晰、气色红润，没有黑眼圈。反之，常于子时内不能入睡者，则气色青白，眼眶昏黑。同时因胆汁排毒代谢不良更容易生成结晶、结石。</p>`
        },
        {
          id: 2,
          title: "丑",
          sub: "肝",
          content: `<p>凌晨1点-3点（丑时）</p>
                    <p>肝经旺：</p>
                    <p>丑时不晚睡，脸上不长斑。</p>
                    <p>养生之道：</p>
                    <p>此时是肝脏修複的最佳时段，需在熟睡中进行。</p>
                    <p>所属病候：</p>
                    <p>腰痛、生殖器痛、胁痛、喉咙作干、疝气等。</p>
                    <p>人体状况：</p>
                    <p>传统医学认为“肝藏血”、“人卧则血归于肝”，如果丑时不能入睡，肝脏还在输出能量支持人的思维和行动，就无法完成新陈代谢，所以丑时前未能入睡者面色青灰，情志怠慢而躁，易生肝病，脸色晦暗长斑。</p>`
        },
        {
          id: 3,
          title: "寅",
          sub: "肺",
          content: `<p>凌晨3点-5点（寅时）</p>
                    <p>肺经旺：</p>
                    <p>寅时睡得熟，色红精气足。</p>
                    <p>养生之道：</p>
                    <p>寅时是呼吸运作最佳的时段，4时是脉搏最弱的时间。</p>
                    <p>所属病候：</p>
                    <p>咳、喘、胸满、缺盆中痛、肩背及臂内侧前缘痛等。</p>
                    <p>人体状况：</p>
                    <p>中医理论认为“肺朝百脉”，肝在丑时把血液推陈出新之后，将新鲜血液提供给肺，通过肺送往全身。所以人在清晨会呈现面色红润，精力充沛。注意，寅时有肺病者反映最为强烈，如剧咳或哮喘而醒。</p>`
        },
        {
          id: 4,
          title: "卯",
          sub: "大肠",
          content: `<p>凌晨5点-7点（卯时）</p>
                    <p>大肠经旺：</p>
                    <p>卯时大肠蠕，排毒渣滓出。</p>
                    <p>养生之道：</p>
                    <p>这时起床要喝水。因卯时是大肠的排毒时段，应上厕所排便，排便不正常者应在此时调理。</p>
                    <p>所属病候：</p>
                    <p>口干、齿痛、鼻塞流涕、鼻出血、颈肿、咽喉胀痛、肩鼻痛等。</p>
                    <p>人体状况：</p>
                    <p>“肺与大肠相表里”，肺将充足的新鲜血液布满全身，紧接著促进大肠进入兴奋状态，完成吸收食物中的水分和营养、排出渣滓的过程。</p>`
        },
        {
          id: 5,
          title: "辰",
          sub: "胃",
          content: `<p>7点到9点（辰时）</p>
                    <p>胃经旺：</p>
                    <p>辰时吃早餐，营养身体安。</p>
                    <p>养生之道：</p>
                    <p>辰时的胃部最活跃，此时一定要吃早餐。另外，每天这时轻敲胃部最好，啓动人体的发电系统。</p>
                    <p>所属病候：</p>
                    <p>鼻出血、口歪、唇生疮、喉头肿胀、腹胀肠鸣、高热、膝盖痛等。</p>
                    <p>人体状况：</p>
                    <p>7点到9点这段时间大部分人都已经起床了，如果有胃痛、胃酸等毛病，建议在这个时间段养胃，因为这段时间是胃经开穴运行的时间，在这个时间段来吃些养胃的食物效果是最明显的。</p>`
        },
        {
          id: 6,
          title: "已",
          sub: "脾",
          content: `<p>9点至11点（已时）</p>
                    <p>脾经旺：</p>
                    <p>已时脾经旺，造血身体状。</p>
                    <p>养生之道：</p>
                    <p>这个时辰需多饮水，慢慢饮，让脾脏处于最活跃的程度。</p>
                    <p>所属病候：</p>
                    <p>呕吐、腹胀、身体沉重、暖气、腹泻、黄疸、膝股内肿胀发冷等。</p>
                    <p>人体状况：</p>
                    <p>“脾主运化，脾统血”，脾是消化、吸收、排泄的总调度，又是人体血液的统领。“脾开窍于口，其华在唇”，脾的功能好，消化吸收好，血液质量好，所以嘴唇是红润的。唇白标志血气不足，唇暗、唇紫标志寒入脾经。</p>`
        },
        {
          id: 7,
          title: "午",
          sub: "心",
          content: `<p>11点至13点（午时）</p>
                    <p>心经旺：</p>
                    <p>午时一小憩，安神养精气。</p>
                    <p>养生之道：</p>
                    <p>此时保持心情舒畅，适当休息或午睡。</p>
                    <p>所属病候：</p>
                    <p>口渴、咽干、心痛、上臂内侧痛等。</p>
                    <p>人体状况：</p>
                    <p>“心主神明，开窍于舌，其华在面”，心气推动血液运行，养神、养气、养筋。饭后如果有条件稍睡10分钟会对心脏有很大的帮助，还有助于肠胃蠕动。</p>`
        },
        {
          id: 8,
          title: "未",
          sub: "小肠",
          content: `<p>13点到15点（未时）</p>
                    <p>小肠经旺：</p>
                    <p>未时分清浊，饮水能降火。</p>
                    <p>养生之道：</p>
                    <p>小肠最活跃的时候，故午餐应在下午1 时前吃。另外，此时适宜喝茶，以帮助肠道吸收。</p>
                    <p>所属病候：</p>
                    <p>耳聋、颊肿、咽喉痛、肩至前臂外侧、前缘痛等。</p>
                    <p>人体状况：</p>
                    <p>小肠分清浊，水液归膀胱，糟粕送大肠，精华输于脾。小肠经在未时对人一天的营养进行调整，此时多喝水、喝茶有利小肠排毒降火。</p>`
        },
        {
          id: 9,
          title: "申",
          sub: "膀胱",
          content: `<p>15点至17点（申时）</p>
                    <p>膀胱经旺：</p>
                    <p>申时津液足，养阴身体舒。</p>
                    <p>养生之道：</p>
                    <p>膀胱最活跃的时候，适合多喝水。</p>
                    <p>所属病候：</p>
                    <p>癫狂、流泪、后顶痛、眼痛鼓出。</p>
                    <p>人体状况：</p>
                    <p>膀胱经贮藏水液和津液，水液排出体外，津液循环在体内。</p>`
        },
        {
          id: 10,
          title: "酉",
          sub: "肾",
          content: `<p>17点至19点（酉时）</p>
                    <p>肾经旺：</p>
                    <p>酉时肾藏精，纳华元气清。</p>
                    <p>养生之道：</p>
                    <p>晚饭宜少量、清谈。</p>
                    <p>所属病候：</p>
                    <p>顔黑、眩昏、舌干、咽喉肿痛，喘咳喷血、脊、腹后内缘疼痛、足心热等。</p>
                    <p>人体状况：</p>
                    <p>“肾藏生殖之精和五脏六腑之精，肾为先天之根”，人体经过申时泻火排毒，肾在酉时进入贮藏精华的阶段。此时不适宜太强的运动量，也不适宜大量喝水。</p>`
        },
        {
          id: 11,
          title: "戌",
          sub: "心包",
          content: `<p>19点至21点（戌时）</p>
                    <p>心包经旺：</p>
                    <p>戌时护心脏，减压心舒畅。</p>
                    <p>养生之道：</p>
                    <p>适宜散步。这时心脑神经系统最活跃，心脏不好的人最好在这时候敲心包经，效果最好。</p>
                    <p>所属病候：</p>
                    <p>心疼、心烦、掌心烧、肘臂拘挛，心中动荡不安、面赤、喜笑不止等。</p>
                    <p>人体状况：</p>
                    <p>“心包为心之外膜，附有脉络，气血通行之道。邪不能容，容之心伤”，心包是心的保护组织，又是气血通道。心包经戌时最兴旺，可清除心脏周围外邪，使心脏处于完好状态。</p>`
        },
        {
          id: 12,
          title: "亥",
          sub: "三焦",
          content: `<p>21点到23点（亥时）</p>
                    <p>三焦经旺：</p>
                    <p>亥时百脉通，养身养娇容。</p>
                    <p>养生之道：</p>
                    <p>保持心境平静，排除杂念，静心安神，以养元气。屈膝而卧，准备入梦。</p>
                    <p>所属病候：</p>
                    <p>耳聋、耳鸣、顔肿、目外眦痛等。</p>
                    <p>人体状况：</p>
                    <p>三焦是六腑中最大的腑，具有主持诸气，疏通水道的作用，亥时三焦能通百脉。人如果在亥时睡眠，百脉可得到最好的休养生息，对身体对美容十分有益。百岁老人有个共同特点，即在亥时睡觉。</p>`
        }
      ],
      temperature: [
        {
          title: "体温",
          content:
            "<p>健康人的体温是相对恒定的，当体温超过正常体温的最高限度时称为发热，就是平常所说的发烧。正常体温根据测试部位的不同，体温的正常值稍有差异。常用的体温包括：口腔温度、直肠温度和腋窝温度。正常体温值为：口腔温度36.3℃～37.2℃，直肠温度比口腔温度约高0.3℃～0.5℃，腋下温度比口腔温度约低0.2℃～0.4℃。</p>"
        },
        {
          title: "发热",
          content: `<p>根据发热程度的高低，具体区分为：低热：37.4℃～38℃；中等度热：38.1℃～39℃：高热：39.1℃～41℃；超高热：41℃以上。</p>
                    <p>发热本身不是一种病，它只是某种疾病的一种临床表现，必要时要及时到医院就诊治疗，针对发热的病因进行积极的处理是解决发热的根本办法。例如：感染性发热，根据感染源不同选择有效药物进行治疗；脱水的患者积极进行补液；发生药物反应时立即停用药物并进行抗过敏治疗等。</p>`
        },
        {
          title: "体温与健康",
          content: `<p>体温的升降与机体免疫力呈正相关系。体温每下降1℃，机体免疫力就下降30%以上，而每升高1℃，免疫力则提高5～6倍。</p>
                    <p>免疫力下降，轻则会患感冒、上呼吸道感染、哮喘、皮炎、肺炎、胆囊炎、节段性回肠炎、溃疡性肠炎和风湿病等，重则会让人患心肌梗塞、脑梗塞等血栓症和胆结石、尿石症等结石病，同时也易导致癌症。</p>
                    <p>运动和劳动会带来生理性的体温上升，根据一些研究结果，在41℃以下人们可以获得发烧带来的若干好处，并且能提高免疫力，通过运动和劳动带来生理性的体温上升，有利于杀灭有害细菌，提高身体免疫力。</p>`
        },
        {
          title: "持续性发热",
          content: `<p>持续4周以上的发热称为持续性发热，引起发热的病因很多，可大致区分为感染性和非感染性两种，而且以感染性发热为常见。出现持续性发热现象时要及时到医院就诊治疗。</p>`
        }
      ],
      xinfei: [
        {
          title: "心肺功能",
          content:
            "<p>心肺功能是人体心脏泵血及肺部吸入氧气的能力，牵涉心脏制血及泵血功能、肺部摄氧及交换气体能力、血液循环系统携带氧气至全身各部位的效率，以及肌肉使用这些氧气的功能。心肺功能直接影响全身器官及肌肉的活动，包括血液的循环速度、心脏跳动的强弱、肺部的容量及次数。心肺功能良好，反应身体主要机能都可健康运作，从而可推断出患慢性疾病如心血管病、内分泌系统疾病、呼吸系统疾病的机会较低。</p>"
        },
        {
          title: "如何锻炼心肺功能",
          content:
            "<p>增强心肺功能可以有效预防心脏病的发生，规则性、持续性、有节奏的有氧运动可锻炼心肺功能，如步行、爬山、游泳、慢跑、跳绳、骑行等。每周从事这类运动3至4次，每次30分钟，即可收到很好的效果。</p>"
        },
        {
          title: "寿命与心肺功能有关",
          content:
            "<p>健康医学研究发现，心肺功能好的人可以活得更长；而心肺功能不健康的人总体死亡率、心血管事件、癌症、肺部疾病等各种风险大大增加。男性中心肺功能最差的人总死亡风险是心肺功能最好的人的3.4倍，女性中甚至达到4.6倍。研究还发现，与我们熟知的传统疾病危险因素相比较，心肺功能不健康导致的总体死亡的作用甚至高于高血压、吸烟、高血脂、高血糖、肥胖等，也就是说，心肺功能低下的危害甚至大于高血压、高血糖等因素。</p>"
        },
        {
          title: "心肺功是健康的基石",
          content: `<p>心肺功能好，心脏就可以承受更高的负荷，身体的运动能力就强，也就是通俗说的“体能好、体力强”。一个人如果“六十岁的年龄拥有三十岁的心脏”，“活动不累、爬山不喘”，这样的身体无疑为我们生活质量的提高打下了基础。</p>
                    <p>心肺功能对于健康的作用目前还没有引起足够的重视，临床医生通常将更多的精力集中在已经发生的各种严重的心血管疾病上，通常只有发生了严重心血管疾病的患者才会进行精确的心肺功能检查。其实从普通健康人甚至儿童青少年开始就应该经常性进行心肺功能的测试和评估，了解自己的体质健康状况，并且根据心肺功能水平“有的放矢”制定身体锻炼计划。</p>`
        }
      ],
      sleep: [
        {
          title: "睡眠",
          content: `<p>睡眠是高等脊椎动物周期出现的一种自发的和可逆的静息状态，表现为机体对外界刺激的反应性降低和意识的暂时中断。</p>
                    <p>睡眠是生命的需要，人的生命约有1/3在睡眠中度过，睡眠可以恢复精神和解除疲劳。</p>
                    <p>人的睡眠过程分为四个阶段：入睡、浅睡、深睡、延续深睡，每一周期的睡眠过程也可由浅至深分为四个睡眠阶段。</p>`
        },
        {
          title: "深度睡眠",
          content: `<p>正常人睡眠时间一般是6-8小时，最佳7-8小时。深度睡眠是睡眠的一个部分，也被称作是“黄金睡眠”，只占整个睡眠时间的25%。深度睡眠可以缓解人们一天的劳累，促进人体的新陈代谢。</p>
                    <p>衡量深度睡眠的标准: 1.入睡快，10-30分钟左右入睡；2.睡眠深，呼吸深长不易惊醒；3.无起夜或很少起夜，无惊梦现象，醒后很快忘记梦境；4.早晨睡醒后，起床快，精神好；5.白天神清脑爽，工作效率高，不困倦。</p>`
        },
        {
          title: "失眠",
          content: `<p>失眠症简称失眠，是指无法入睡或无法保持睡眠状态，导致睡眠不足。生理学实验表明，缺乏睡眠的人，不仅免疫能力大幅度降低，每天的衰老进程是正常人的4-5倍。</p>
                    <p>成年人失眠的诊断标准：①失眠表现入睡困难，入睡时间超过30分钟；②睡眠质量睡眠质量下降，睡眠维持障碍，整夜觉醒次数≥2次、早醒、睡眠质量下降；③总睡眠时间总睡眠时间减少，通常少于6小时。</p>`
        },
        {
          title: "睡眠基准心率",
          content: `<p>睡眠基准心率是相对连续的一段时间区域内，睡眠时出现最多的心率数值。睡眠基准心率反映了个体在睡眠期间的基础心率水平，是判断心脏健康状态的重要依据。</p>
                    <p>睡眠基准心率处于55—65次/分钟之间，表明心脏机能良好，负荷低。</p>
                    <p>睡眠基准心率少于43次/分钟，可能存在缓慢性心律失常的风险，有可能导致心脏停搏。</p>
                    <p>睡眠基准心率大于70次/分钟，表明心脏负荷程度较高，心脑血管疾病风险增大。</p>
                    <p>对冠心病患者，基准心率每增加10次/分钟，主要心血管事件风险增加8% ；心率>70次/分钟，全因死亡风险增加40%，心力衰竭住院风险增加两倍以上。</p>`
        }
      ],
      fat: [
        {
          title: "过度疲劳",
          content:
            "<p>疲劳是指由于工作时间过长、劳动强度过大、心理压力过重等导致精疲力竭的亚健康状态。它最大的隐患是引起身体潜藏的疾病急速恶化，比如导致高血压等基础疾病恶化引发脑血管病或者心血管病等急性循环器官障碍，甚至出现致命的症状。长期慢性疲劳后诱发的猝死就是“过劳死”。</p>"
        },
        {
          title: "疲劳影响",
          content: `<p>经常加班、熬夜、休息不好，时间长了就会导致焦虑、失眠、记忆力减退、精神抑郁，甚至引发抑郁症和精神分裂症。如果这种疲劳持续6个月或更长时间，身体就可能会出现低烧、咽喉肿痛、注意力下降、记忆力减退等症状。而且，非常严重的长期性疲劳很可能就是其他病症的先兆。人们常说的“过劳死”实际是长期过度的劳累或超强度劳累，引发人体心衰、肺衰、肾衰、心肌梗、脑溢血等病症造成的猝死。</p>`
        },
        {
          title: "産生疲劳的原因",
          content: `<p>生活无规律，为应付繁重工作、加班、熬夜或不正常作息而休息不足；病后身体尚未恢复，过早工作、活动；参加某些劳动或活动之后，疲劳尚未消除，体力尚未恢复便参加大运动量锻炼等；运动量大而且持续时间较长；睡眠不足，休息时间不够等。</p>`
        },
        {
          title: "职业病过劳肥",
          content: `<p>由于压力大、工作累，越来越多的职场人士体重飙升，这种现象被称为“过劳肥”，它正在日益威胁著上班族的健康。工作压力累积到顶峰，职业人士要特别注意防止“过劳肥”，越是忙碌越要三餐准点吃，每天晚上11点前入睡，保证6至8小时睡眠，最好每周能有三次以上的有氧锻炼，每次不少于半小时。</p>`
        }
      ],
      steps: [
        {
          title: "运动活动",
          content: `<p>运动活动是任何消耗能量的身体运动或锻炼形式。有些日常活动比如：做家务、整理花园、遛狗等都包括其中。<p>
                    <p>运动活动可以促进健康，步行、跑步、跳舞、游泳和打篮球等这些有氧运动，还包括那些锻炼肌肉的无氧练习，比如俯卧撑和举重等，都能让人的呼吸更加有力，心血管更加健康。</p>`
        },
        {
          title: "医疗体育",
          content:
            "<p>指运用体育手段治疗某些疾病与创伤，恢复和改善机体功能的一种医疗方法。一般不受时间、地点、设备条件的限制。通常采用医疗体操、慢跑、散步、自行车、气功、太极拳和特制的运动器械(如拉力器、自动跑台等)，以及日光浴、空气浴、水浴等为治疗手段。宜因人而异、持之以恒、循序渐进，并配合药物或手术治疗和心理疏导。</p>"
        },
        {
          title: "健步走",
          content: `<p>健步走是一项以促进身心健康为目的、讲究姿势、速度和时间的一项步行运动，它行走的速度和运动量介于散步和竞走之间。</p>
                    <p>健步走的健身作用主要体现在：提高心肺功能和耐力、改变血液质量、调节血管机能、减肥、促进骨关节健康、增加人体免疫能力、改善心理状态、改善睡眠质量等。</p>`
        },
        {
          title: "健走方法",
          content: `<p>健步走是在自然行走的基础上，躯干伸直，收腹、挺胸、抬头，随走步速度的加快而肘关节自然弯曲，以肩关节为轴自然前后摆臂，同时腿朝前迈，脚跟先著地，过渡到前脚掌，然后推离地面。健步走时，上下肢应协调运动，并配合深而均匀的呼吸。</p>
                    <p>健步走速度的快慢是决定锻炼效果的关键因素，通常因人而异地可分为慢步走（每分钟约70－90步）、中速走（每分钟90－120步）、快步走（每分钟120－140步）、极快速走（每分钟140步以上）。</p>`
        }
      ],
      manualrate: [
        {
          title: "心律失常",
          content: `<p>心律即心脏跳动的频率和（或）节律。心律失常是指心脏电传导系统异常所引起的心跳不规则、过快或过慢等症状的总称，分为遗传性或后天获得性，轻者感心悸、头晕，重者可晕厥、猝死。通过服抗心律失常药物或接受手术治疗，辅以生活方式改善，定期随诊复查，大多可有效控制病情，长期生存。</p>`
        },
        {
          title: "疾病类型",
          content: `<p>临床上根据心律失常的发生部位、机制及频率不同，可有不同的分类方法。</p>
          <p>按发生部位：分为室上性（包括窦性、房性、房室交界性）和室性心律失常两大类；</p>
          <p>按发生机制：分为冲动形成异常和冲动传导异常两大类；</p>
          <p>按发生的频率快慢：分为快速型与缓慢型失常两大类。</p>
          <p>临床上常以心率快慢进行分类。</p>
          <p>常见的缓慢型心律失常（心率<60次/分）包括：窦性心动过缓、窦性停博、病态窦房结综合征、窦房传导阻滞（Ⅰ、Ⅱ、Ⅲ度）。</p>
          <p>常见的快速型心律失常（心率>100次/分）包括：早搏、窦性心动过速、房性心动过速（心房扑动、心房颤动）、室上性心动过速、室性心动过速（心室扑动、心室颤动）等。</p>`
        },
        {
          title: "症状表现",
          content: `<p>典型症状——随着疾病的发生发展，患者发病早期可有心悸、出汗、乏力、憋气等症状，此时，若心律恢复正常则无严重不适，若进一步发展可导致头晕、黑矇、晕厥，甚至猝死等。</p>
          <p>伴随症状——心律失常伴有明显的外周血流动力学障碍时，会出现相应器官受损的症状：</p>
          <p>脑：视力模糊、头晕、黑矇、晕厥等；</p>
          <p>胃肠道：腹胀、腹痛、腹泻等；</p>
          <p>肾：尿频、尿急、多尿等；</p>
          <p>肺：胸闷、气促、呼吸困难等。</p>`
        },
        {
          title: "日常预防",
          content: `<p>降低心律失常发病率，预防措施包括</p>
          <p>健康的饮食：低盐、低脂，适当摄入水果、蔬菜和坚果。</p>
          <p>适度的运动：注意休息和适当运动。</p>
          <p>稳定的情绪：保持平和稳定的情绪，精神放松，不过度紧张。</p>
          <p>合理的用药：谨慎使用非处方药物，遵医嘱合理用药。</p>
          <p>自我监测：定时监测脉搏，每次测量时间不少于 1分钟，定期体检。</p>`
        }
      ]
    },
    xiaotieshi: {
      xinlv: {
        title: "心率评级小贴士",
        text:
          "<p>心率健康从A级到E级递减，A级最健康，也是推荐健康人群最好要达到的级别，而E级则是最危险的心率。心率到达C级或更低就一定要进行心率管理了。大量临床观察证实，如果患者的心率达标，不仅能大大减少猝死、心肌梗死、脑卒中等恶性事件的发生，还能有效提高患者的生活质量。</p><p>一般建议，普通高血压患者，心率超过每分钟70次就必须考虑进行心率管理，适当降低心率。高血压合併冠心病或心力衰竭的患者，最佳心率为55-70次/分，有利于患者的长期预后。</p>"
      },
      blood: {
        title: "血压评级小贴士",
        text:
          "<p>高血压病的分级，主要是依据血压的水平来进行分级。从一级到第三级逐渐递增，三级最高。</p>"
      }
    },
    tieshi: "小贴士",
    xinlv: {
      ci: "次",
      yuebaojing: "月报警天数",
      nianbaojing: "年报警天数",
      jinrijingxi: "今日静息心率",
      zuorijingxi: "昨日静息心率",
      qiantianjingxi: "前天静息心率",
      jiankangcankao: "健康参考心率",
      danwei: "次/分",
      zuigao: "最高心率",
      zuidi: "最低心率",
      pingjun: "平均心率",
      quantianpingjun: "全天平均心率",
      yejianpingjun: "夜间平均心率",
      rijianpingjun: "日间平均心率",
      jinrizuigao: "今日最高心率",
      jinrizuidi: "今日最低心率",
      zuorizuigao: "昨日最高心率",
      zuorizuidi: "昨日最低心率",
      xinlvpinggu: "心率评估",
      jinrixinlvpinggu: "今日心率等级评估",
      zuorixinlvpinggu: "昨日心率等级评估",
      weekPG: "本周心率等级评估",
      monthPG: "本月心率等级评估",
      yearPG: "本年心率等级评估",
      noday: "暂无日心率数据！",
      noweek: "暂无周心率数据！",
      nomonth: "暂无月心率数据！",
      noyear: "暂无年心率数据！"
    },
    blood: {
      current: "当前血压",
      todayTop: "今日最高",
      todatAve: "今日平均",
      allave: "全天平均",
      yesAve: "昨日平均",
      todayPG: "今日血压等级评估",
      yesPG: "昨日血压等级评估",
      yiji: "一级高血压",
      erji: "二级高血压",
      sanji: "三级高血压",
      zhengchang: "正常",
      weekPG: "本周血压等级评估",
      monthPG: "本月血压等级评估",
      yearPG: "本年血压等级评估",
      noday: "暂无日血压数据！",
      noweek: "暂无周血压数据！",
      nomonth: "暂无月血压数据！",
      noyear: "暂无年血压数据！"
    },
    bloodsugar: {
      current: "当前血糖",
      todatAve: "平均血糖",
      todayTop: "今日最高",
      todaylowest: "今日最低",
      yesTop: "昨日最高",
      yealowest: "昨日最低",
      aveYes:"昨日平均",
      gluPre: "空腹血糖",
      gluPreyunsuan:'AI运算中',
      ave: "平均血糖",
      height: "最高血糖",
      lowest: "最低血糖",
      weekPG: "本周血糖等级评估",
      monthPG: "本月血糖等级评估",
      yearPG: "本年血糖等级评估",
      noday: "暂无日血糖数据！",
      noweek: "暂无周血糖数据！",
      nomonth: "暂无月血糖数据！",
      noyear: "暂无年血糖数据！"
    },
    bloodoxygen: {
      current: "当前血氧",
      todatAve: "今日平均",
      todayTop: "今日最高",
      todaylowest: "今日最低",
      yesTop: "昨日最高",
      yealowest: "昨日最低",
      ave: "平均血氧",
      top: "最高血氧",
      low: "最低血氧",
      weekPG: "本周血氧等级评估",
      monthPG: "本月血氧等级评估",
      yearPG: "本年血氧等级评估",
      noday: "暂无日血氧数据！",
      noweek: "暂无周血氧数据！",
      nomonth: "暂无月血氧数据！",
      noyear: "暂无年血氧数据！"
    },
    temperature: {
      current: "当前体温",
      todatAve: "今日平均",
      todayTop: "今日最高",
      todaylowest: "今日最低",
      yesTop: "昨日最高",
      yealowest: "昨日最低",
      low: "最低体温",
      top: "最高体温",
      ave: "平均体温",
      weekPG: "本周体温等级评估",
      monthPG: "本月体温等级评估",
      yearPG: "本年体温等级评估",
      noday: "暂无日体温数据！",
      noweek: "暂无周体温数据！",
      nomonth: "暂无月体温数据！",
      noyear: "暂无年体温数据！"
    },
    fat: {
      noday: "暂无日疲劳数据！",
      noweek: "暂无周疲劳数据！",
      nomonth: "暂无月疲劳数据！",
      noyear: "暂无年疲劳数据！"
    },
    zangfu: {
      hight: "最高心率",
      low: "最低心率",
      ave: "平均心率",
      today: "今日",
      thisweek: "本周",
      thismonth: "本月",
      thisyear: "本年",
      yichang: "异常状态",
      fengxian: "风险状态",
      zishi: "子时(23点至01点)",
      choushi: "丑时(01点至03点)",
      yinshi: "寅时(03点至05点)",
      maoshi: "卯时(05点至07点)",
      chenshi: "辰时(07点至09点)",
      sishi: "巳时(09点至11点)",
      wushi: "午时(11点至13点)",
      weishi: "未时(13点至15点)",
      shenshi: "申时(15点至17点)",
      youshi: "酉时(17点至19点)",
      xushi: "戌时(19点至21点)",
      haishi: "亥时(21点至23点)",
      jiancetitle: "您现在正处于",
      cankao: "健康参考心率",
      shijianduan: "监测段",
      tip: "点击时辰按钮查看健康解读",
      noday: "暂无日脏腑数据！",
      noweek: "暂无周脏腑数据！",
      nomonth: "暂无月脏腑数据！",
      noyear: "暂无年脏腑数据！",
    },


    zangfujielu:{
      1:{
        yichang:"子时这两时辰应该安然入睡，以保养人的元气。睡时，身体要侧面睡着，一只脚屈着放在另一只脚上。要让自己的心情平静下来，什么都不要想，只有先睡心了，人才能入睡。这样心无杂念，安心入睡，才是调神养气的法宝。",
        fengxian:"胆气始生,睡觉保护阳气。子时在夜里23点到次日凌晨1点，在这个时间段，胆经当令，阳气开始生发，最重要的是好好睡觉、养阳气。胆气生发起来，全身气血才能随之而起，五脏六腑皆受其益。可是，现实生活中很多人晚上八九点钟就昏昏欲睡，而一到11点就清醒了，于是就习惯11点以后开始工作、通宵玩游戏、吃东西，这样恰恰把正在慢慢生发的阳气给破坏了。对于习惯熬夜的人们来说，照顾好胆经才是最好的进补。有一种敲胆经的方法非常奏效，沿大腿外侧中线从屁股直敲到膝盖，两条腿都要敲，每日每条腿敲3~5分钟，无论是站是坐，都可以方便地操作。此时胆开始工作，分泌并储存胆汁，为第二天的需要做好准备，所以，人一定要在这个时候熟睡，否则会影响胆的工作，令胆汁分泌不足，熬夜的人容易面黄，就是造血功能受影响的原因，长期熬夜的人会贫血。若子时觉得很精神，睡不着觉，便是气血不足的危险信号;要养成良好的睡眠习惯，可以按摩脚心的涌泉穴，以改善睡眠。睡眠不足会加速衰老。",
      },
      2:{
        yichang:"丑时为人体精气生发的时候，如果此时失眠，可披着被子，坐在床上，呵一两口气，把体内浊气吐出。然后把两只手搓热，摩擦鼻子两旁，并用搓热的手慰热双目35遍。接着把两只耳朵分别向前向后揉卷35遍。然后用两只手抱住后脑，双手的手心恰好掩住双耳，用食指去弹中指,用来击打后脑勺24次。完毕后，再左右耸跳身子，舒展双臂，像开工一样，做49遍。最后，漱嘴里的唾液满口，用意念送下丹田，作三口咽下，可清除五脏之火,达到减息的目的。",
        fengxian:"肝经造血时间，保持熟睡丑时在凌晨1点到3点，此时肝经当令。肝主目，和人体的眼睛联系密切，“卧则血归于肝”, 这个时候一定要保证良好的睡眠，保持熟睡是是对肝最好的关怀。同时，“肝主藏血”，人的生发之机全都仰赖肝的疏泄功能。不要为了应酬大量喝酒，那样只会增加肝疏泄毒素的工作量，使肝脏功能越来越糟糕。也不能为白天的不愉快而生气郁闷，那样只会抑制肝的疏泄、生发功能，容易导致气郁。遇到这种情况，最好找合适的人把烦心委屈的事随感而发。“肝之液为泪”，眼泪是上天赐子每个人的自然解毒法，可以迅速化解肝毒，将体内的郁结及时疏解。此时肝开始解毒，过滤血液中的毒素，把多余的血藏在肝脏里，此时绝对不能喝酒，否则对肝的损伤是致命的。这时人要处在深度睡眼之中，把肝养好了，人才会才思灵敏，否则会变得木讷，肝血气的强弱表现在头发上，如果一个人年龄不大，满头白发，说明这人肝弱或者早年得过肝病。眼于涩是肝虚用眼过度伤肝。",
      },
      3:{
        yichang:"寅时为人体精气生发的时候，如果此时失眠，可披着被子，坐在床上，呵一两口气，把体内浊气吐出。然后把两只手搓热，摩擦鼻子两旁，并用搓热的手慰热双目35遍。接着把两只耳朵分别向前向后揉卷35遍。然后用两只手抱住后脑，双手的手心恰好掩住双耳，用食指去弹中指,用来击打后脑勺24次。完毕后，再左右耸跳身子，舒展双臂，像开工一样，做49遍。最后，漱嘴里的唾液满口,用意念送下丹田,作三口咽下，可清除五脏之火,达到减息的目的。",
        fengxian:"浓睡转轻时机，五更养肺得宜，号脉的最好时机。寅时在凌晨3点到5点。人体气血在这个时候开始冲击肺经，而肺经是“主一身之气” 的，人们一定要处在深度睡眠当中才能完成人体从静到动的转化，让人体的气血好好地来分配。这也就是为什么不睡的人在夜间3 ~ 4点会那么难熬，因为这个时候为肃降之气运行的阶段，要是继续熬夜，对人体的伤害非常大。而很多上了年纪的人，这个时候往往会醒来，甚至还有盗汗的情况发生。这是因为老年人的身体各项机能不如从前，收复功能也越来越差，就只剩下宣发而没有肃降，所以老年人容易早醒。如家里有老年人和心脏病人，就一定要叮嘱他慢慢起床，不要过早去锻，以免因为生硬地调-一些气血上来，而引起猝死。如果寅时醒了，或是大汗淋漓，都是身体不好的信号，肺主气，均衡一身的气血，寅时一定要深度睡眠，如果此时惊醒或盗汗，将是大病的表现，一定要去看医生。",
      },
      4:{
        yichang:"在起床时，要根据气候的寒暖选择适当的衣服。起床后，可坐在明亮的窗户下，喝杯白开水，不要喝茶。再梳头发百余下，可疏风散火，明目去脑热。洗漱完毕后，应该喝一点淡粥，吃饱后稍休息，再徐徐行走五六十步，边走边用手摩挲肚子。如果此时要出门或不出门但感觉疲倦，可以喝一点点酒，可用来养真气",
        fengxian:"喝空腹水，排夜浊气，早起晨练。卯时在早晨5点到7点，此时大肠经当令。大肠经的功能是转化糟粕，及时将人体的垃圾清理出体外。每天按时排便可以减轻大肠经的负担，达到润肠排毒的的养生效果。如果排便不通畅，应该憋一口气而不是攥拳头,因为肺与大肠相表里,这里的气就是肺气,它可以推动大便下来。另外,早晨起床后,先喝一杯白开水不仅能让大肠蠕动旺盛，还能将唾液中的消化酶带进肠胃，吃东西时,可以更充分的分解食物。不过和睡之前,应该先刷牙,以免形成菌斑及牙石。大肠经还是一条非常有效的美容经,因为这条经直通面部两颊和鼻翼，可以有效防止这些部位长斑、生痘。方法是右手攥空拳敲打左臂大肠经(左手自然下垂，右手从上臂敲打到手腕)，再左手攥空拳敲打右臂大肠经，每边各敲打约1分钟。此时太阳初升,人应该醒来,要起身去大小便。",
      },
      5:{
        yichang:"辰时可以用来读书看报，或处理家务，或到公园里散步，赏花赏鸟，并要开开心心地享受这段时光，不要因为些小事而动气。回到屋里后，要闭目养神，或叩齿咽津数十口。这样做是因为从亥、子两个时辰开始，真气就到了，到了已午时真气就逐渐减少，因此此时应定神调息，以用来调养真气。",
        fengxian:"营养早餐好，保养胃气少不了。辰时在早晨7点到9点，这时太阳升起，天地出现一片阳的象，而此时正是胃经当令，人体需要补充一些阴的东西，水分多、味道淡的食物就属于阴。这个时候应该吃早饭，补充营养。它们如同“春雨贵如油”一样金贵，是人体最好的保养。如果没有吃早饭，到了9点的时候就会头晕、注意力不集中、工作学习效率低，长期下去对人体的损伤非常大。此时吃一顿丰盛的早餐非常必要， 这关系到一天的精神，不吃早餐会伤胃，人的生命靠胃经养育，胃经一旦绝断，将回天无术。古代中医抢救重症病人时，会给病人喂一块麦饼，若病人不能消化，说明他的胃经已绝，医生就会放弃救治，可见胃经对人多么重要，胃经要靠人后天的养护。",
      },
      6:{
        yichang:"巳时可以用来读书看报，或处理家务，或到公园里散步，赏花赏鸟，并要开开心心地享受这段时光，不要因为些小事而动气。回到屋里后，要闭目养神，或叩齿咽津数十口。这样做是因为从亥、子两个时辰开始，真气就到了，到了已午时真气就逐渐减少，因此此时应定神调息，以用来调养真气。",
        fengxian:"消化吸收好，工作学习效率高巳时在上午9点到11点，这个时间脾经当令。脾经是主消化的,早上吃的饭在这个时候开始运化，这样大脑才有能量应付日常的运转。不过这也有赖于牌运化水谷精微之物的功能，这是因为脾主一身肌肉，如果脾的功能很好，我们的肌肉就会很发达，嘴唇就很滋润、很丰满，反之，嘴唇就会发瘪、干枯。这时不妨多吃具有补脾气作用的食物，少吃寒凉、油腻的食物。对于现代上班族还要避免久坐，因为长时间坐着不动，周身气血运行缓慢，脾的功能容易受到影响。养身健脾最主要的方法就是“多动”，即使没有时间去健身房，也要每隔段时间站起来做做简单的伸展运动。另外，还不能过度思虑，一旦脾胃受到伤害，吃饭也不会有胃口,人就会消瘦。此时是锻炼肌肉的好时机，如果发现自己开始发福，肚子见长，并且全身虚胖，喝凉水都发胖，说明脾虚，也就是说身体需要的营养运不进来，代谢的废物又运不出去，只好暂时堆积在肚皮下，等待脾修养好了有能力运化的时候，才往外运一如果一直不注意养牌。运不出去的废物就会堆积在心包里和血管里，人就容易得慢性病。脾虚的人特点是很懒，不爱干活。补脾最好的食材是枣，吃太多枣又会伤牙，最好把事切成小块，去除内部硬核后再吃，或者用粉碎机打成枣浆再吃，避免直接用牙咀嚼。",
      },
      7:{
        yichang:"此时，要根据自己的饭量去吃饭，不要勉强。午餐吃得要好，尽量丰盛、齐全些。这里说的吃得好，并非一定是山珍海味，而是要吃加工熟的食物，不吃生冷和坚硬的食物。午餐不可吃得过饱，饭后应站起来走上百余步，然后抚摸腹部，再转手抚摸肾堂，让它热起来，使得肾和脾运动起来。然后再喝点茶水，不要喝得过量。",
        fengxian:"睡好午觉养阳气。午时在中午11点到13点，心经当令。此时是午餐时间，吃饭要注意营养丰富，荤素搭配，不要吃生冷坚硬的食物，吃八分饱足矣，建议多喝点汤，菜要少放盐，饭后用茶水漱口，涤去油腻，然后再进行午休。上午运化的全是阳气，这个时候是阴生，天地之气在这个时间段转换，睡子午觉是最好的选择，哪怕是闭一会儿眼睛对身体也有好处，尤其是高血压患者，午休最有补益。午时间不要太长，最多不要超过1小时。此时是阴阳交汇点,午饭后最好睡半小时，对女人尤其重要。没时间午睡的人，宁心静气平和地、自然地十指相合，呈拜佛状，眼观鼻，鼻观口，口观心，慢慢闭上眼睛，也能让心得到一点休息。如果一个人经常口是心非，心里明明想这样说，心里不知不觉说了另外一番话，这时便要提高警觉，可能是心系统出了问题，最好去医院检查一下。",
      },
      8:{
        yichang:"未时最好午休片刻，醒来后，可看书、写作或邀朋友叙叙，或出去散散步，放松自已，不要太过劳苦。",
        fengxian:"消化吸收时， 保护血管多喝水未时在13点到15点，此时小肠经当令。它的作用是吸收被牌胃腐熟后的食物的精华，分配到身体的各个脏器。午饭定要吃得营养、全面，这样才能保证下午的精力充沛。当然，这也不是说吃了好东西就能“补”什么，也不是要吃很多，这还与身体吸收功能的好坏有关，如果吸收功能较差，即使吃再好的东西，体内不能消化吸收，也照样会堆积成垃圾，人体还得调出元气来消化它，反而会使身体变得更虚弱。所以，膳食搭配还得根据个人情况，做到有的放失。有些女性脸上长了蝴蝶斑，就是典型的小肠吸收功能不好引起的，体内垃圾没有代谢出去，慢慢堆积而成，这时光靠美容是没有用的，需要内外一起调养， 疏通代谢,斑点才会自然地消失。此时小肠正在吸收午饭消化后的精华，如果一个人眼角下皱纹多，比平时脸大脖子粗，说明小肠不太健康。",
      },
      9:{
        yichang:"申时可吃点小点心或果品。此时也是上班族的下午茶时间，更是看书、绘画的良机",
        fengxian:"工作，学习的第二个黄金时间申时在15点到17点，是膀胱经当令的时候。膀胱经是一条可以走 到脑部的经脉。对于健康的正常人，这个时间办事效率高、判断力好；对于企业，在这个时间可以开例会、做重要的决策。如果此时特别犯困、健忘，平时睡眠是又较规律的，就可能是膀胱经出了问题，是阳虚的毛病。这里介绍种简单易行的锻炼膀胱经方法：面对墙壁、做下蹲起立的练习。初练时离墙壁销远点，随着腰背力量的增加，逐渐缩短足尖与墙自距离，直至练到足尖抵住墙壁时，仍然自蹲起自如，每天坚持做10分钟便可。有些老年人，口唇一干燥就认为是肾阴虚，往往越补越口干。其实，人体的膀胱与肾相表里膀胱就像太阳一样，能够把精液气化，如膀胱经的气化功能好，嘴里就会有唾液，反之，就会口唇干燥。所以，遇到这种干燥症患者，要先从肾阳和膀胱经的气化功能两方面来考虑。这段时间最好多喝水，通过尿液把代谢后的废液排出。小便时，脚趾抓地，牙用劲空咬，就像后牙之间有个果核，然后不言不语，舌尖顶下颚，这样可以养肾气。申时是学习、背诵和练习的好时间，学习效果将大大提高。",
      },
      10:{
        yichang:"酉时应该是吃晚饭的时间了，但不能吃得太迟或太饱，可以少喝点酒，不要喝醉。",
        fengxian:"预防肾病的最佳时期。酉时是17点到19点，肾经当令。肾是先天之本，是一个人生命的本钱，大多来自父母的遗传，先天不足则要靠后天的培补。如果一个人心灵手巧，说明他的肾精很足。肾精足的另一个表现就是志向，小孩子精足，志向就高远，而老年人精不足，志向就不会高远。所以，人要做大事，首先就是要保住自己的肾精。涌泉穴直通肾经，是浊气下降的地方，经常按摩此穴可以益精补肾、强身健体、防止早衰。肾经上的太溪穴也是一个大补穴，凡是肾虚引起的各种症状，如头晕、耳鸣、腰酸、脱发、牙齿松动、哮喘、男人性功能减退、女性习惯性流产都可以通过刺激这个穴位缓解病症。肾弱的人宜在此时吃豆类补肾气。开精越多越好，元气不足需补，能否有效地补元气，还要看消化吸收的能力，所以补肾的关键是脾胃健康正常。晚餐要少吃盐，如果一个人有大量脱发的现象，说明肾的收敛功能不好，是肾虚的表现，坐不住的人，说明消耗肾气太多或肾虚。",
      },
      11:{
        yichang:"戌时可用热水泡脚，可以降火、活血、除湿。并且用凉茶水漱口，可以去除食物的残渣和毒火。睡前可以看一会书，但不能看得太久，否则会损伤眼睛。此时不能多想问题，因为此时思虑过多会造成心火上炎，引起肾水不足，容易导致心肾不交，易患性功能障碍。所以在这个时候，应尽量使心绪安宁，静心养气，早早入睡。此外，睡之前可以按摩左右脚心的两个涌泉穴数百次，可保养人的精气。",
        fengxian:"缓慢调整，平心静气。此时是工作学习的第三个黄金时间。戌时在19点到21点，“阴气正盛，阳气将尽”，男人与女人要保持心情舒畅，从内心深处来愉悦自己，为亥时进行性生活做好准备。此时恰是心包经当令，心经是君主之宫，是不受邪的，而是由心包经“代君受过”。每天应该抽出10分钟，去拍打心包经，这可以让身体得到全方位的休息。心包经上有一个非常重要的穴位膻中穴，这个穴位于两乳的正中线，是解郁、解压的大穴。当人被气着时，会不由自主地拍打自己的胸膛，实际上这就是在拍打膻中穴。对患有失眠症的人来说，拍打心包经也是消除失眠的好方法。此时敲打、按摩心包绛和轻揉鹏中穴，可以缓解心慌的问题:朋友相聚，心平气和地聊天，即可养心:热水泡脚，到要发汗面还没出汗的时候停止，既可祛寒气、通经络，又能活血化瘀。",
      },
      12:{
        yichang:"亥時两个时辰应该安然入睡，以保养人的元气。睡时，身体要侧面睡着，一只脚屈着放在另一只脚上。要让自己的心情平静下来，什么都不要想，只有先睡心了，人才能入睡。这样心无杂念，安心入睡，才是调神养气的法宝。",
        fengxian:"三焦大军汇集，身体全面休整，准备休息。亥时在21点到23点，这段时间三焦经当令。亥时是十二时中最后一个时辰，意为夜已很深，人们应该停止活动，安歇睡眠，这样百脉才可休养生息。亥时在人体对应的经脉是三焦，人体很多脏器全都包括在三焦内。上焦是心和肺，中焦是脾和胃，下焦是肝和肾。只有保持三焦通畅，人体才能健康;若是三焦不通畅，人就会生病。此时最好不吃不喝，睡觉是最好的选择，尤其是病人此时入睡，对养病特别重要。即使正常人，晚上入睡时间最好也不要超过23时。",
      },
    },


    xinfei: {
      todayxinfei: "当前心肺功能",
      yesxinfei: "昨日心肺功能",
      zhuangtai: "今日心肺功能状态",
      weekzt: "本周心肺功能状态",
      monthzt: "本月心肺功能状态",
      yearzt: "本年心肺功能状态",
      weekPG: "本周心肺等级评估",
      monthPG: "本月心肺等级评估",
      yearPG: "本年心肺等级评估",
      noday: "暂无日心肺数据！",
      noweek: "暂无周心肺数据！",
      nomonth: "暂无月心肺数据！",
      noyear: "暂无年心肺数据！"
    },
    sleep: {
      deepSleep: "深度睡眠",
      lightSleep: "浅度睡眠",
      wakeSleep: "清醒时长",
      allTime: "总睡眠时长",
      dayave: "日平均睡眠时长",
      daydeepave: "日平均深睡时长",
      noday: "暂无日睡眠数据！",
      noweek: "暂无周睡眠数据！",
      nomonth: "暂无月睡眠数据！",
      noyear: "暂无年睡眠数据！"
    },
    sports: {
      kaluli: "消耗热量",
      allStep: "当前有效步数",
      dqStep: "当前总步数",
      yesStep: "昨日总步数",
      jinristep: "今日总步数",
      todayMile: "当前累计行程",
      yesMlie: "昨日累计行程",
      leiji: "累计行程",
      todaySteps: "今日有效运动量",
      yesSteps: "昨日有效运动量",
      dailyCal: "日平均消耗热量",
      weekbu: "周步数总量",
      weekmile: "周累计行程",
      monthbu: "月步数总量",
      monthmile: "月累计行程",
      yearbu: "年步数总量",
      yearmile: "年累计行程",
      dailyavebu: "日平均步数",
      wanbu: "万步",
      daydabiao: "天达标",
      youxiao: "有效运动量",
      noday: "暂无日运动数据！",
      noweek: "暂无周运动数据！",
      nomonth: "暂无月运动数据！",
      noyear: "暂无年运动数据！"
    },
    xindian: {
      title: "心电",
      xinlv: "心率",
      xueyang: "血氧",
      fangchan: "房颤",
      text: "日心电数据还没有上传",
      time: "测量时间"
    },
    breathe: {
      dangqian: "当前呼吸",
      pingjun: "平均呼吸",
      jinrizuigao: "今日最高",
      zuorizuigao: "昨日最高",
      jinrizuidi: "今日最低",
      zuorizuidi: "昨日最低",
      quantianpingjun: "全天平均频率",
      yejianpingjun: "夜间平均频率",
      rijianpingjun: "日间平均频率",
      zuigao: "最高频率",
      zuidi: "最低频率",
      pingjun: "平均频率",
      huxipinggu: "呼吸评估",
      jinrihuxipinggu: "今日呼吸等级评估",
      zuorihuxipinggu: "昨日呼吸等级评估",
      weekPG: "本周呼吸等级评估",
      monthPG: "本月呼吸等级评估",
      yearPG: "本年呼吸等级评估",
      noday: "暂无日呼吸数据！",
      noweek: "暂无周呼吸数据！",
      nomonth: "暂无月呼吸数据！",
      noyear: "暂无年呼吸数据！"
    }
  },

};



// WEBPACK FOOTER //
// ./src/lang/zh.js